//import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
import {request} from "../utils/request.js";

function dodajCoPiec(tablica, nowyElement) {
  for (let i = 4; i < tablica.length; i += 5) {
    tablica.splice(i + 1, 0, nowyElement);
    i++;
  }
  return tablica;
}


export const openPhotoSwipe = async (id) => {
  const book = await request("/wp-admin/admin-ajax.php?action=fetch-book&id=" + id, {
    method: "GET"
  });

  let pages = book.pages;
  pages = dodajCoPiec(pages, {
    html: '<div><iframe src="/wp-content/themes/alleprospekte/mobile-ads.html" style="width:100%; height:400px; margin-top:60px"></iframe></div><img style="width:100px; display:block; margin:70px auto 0" src="/wp-content/themes/alleprospekte/dist/assets/swipe.svg" />'
  });

  const options = {
    dataSource: book.pages,
    showHideAnimationType: 'none',
    index: 0
  };

  const pswp = new PhotoSwipe(options);
  pswp.init();
}
